<template>
  <div class="mine">
    <div class="top">
      <div class="setting" @click="showSetting">
        <van-icon name="setting-o" color="#fff" size="24" />
      </div>
      <div class="avatar" @click="doLogin">
        <van-image
          round
          width="4.2rem"
          height="4.2rem"
          :src="userInfo.header_img || '/img/avatar.png'"
        >
          <template #loading>
            <van-loading type="spinner" />
          </template>
          <template #error>
            <img src="/img/avatar.png" class="avatar-fallback" alt="" />
          </template>
        </van-image>
        <div class="me">
          <div class="user">
            <div class="user-row">
              <p class="username">{{ userInfo.username }}</p>
            </div>
            <div class="progress-wrap">
              <div class="progress-bar">
                <div class="progress-fill" :style="{ width: vipProgress + '%' }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="center">
      <div class="integral">
        <div class="integral-item">
          <div class="integral-label">{{ $t('my.account_point') }}</div>
          <div class="integral-value">{{ accountPoint }}</div>
        </div>
        <div class="integral-item">
          <div class="integral-label">{{ $t('my.credit_score') }}</div>
          <div class="integral-value">{{ userInfo.credit || 0 }}</div>
        </div>
      </div>


      <div class="action-list">
        <div
          v-for="item in actionItems"
          :key="item.path"
          class="action-item"
          @click="goPage(item.path)"
        >
          <div class="action-title">
            <div class="action-icon">
              <img :src="item.icon" alt="" />
            </div>
            <div>{{ $t(item.labelKey) }}</div>
          </div>
          <div class="action-button">
            <van-icon name="arrow" />
          </div>
        </div>
      </div>

      <a class="btns" href="#" @click.prevent="loginout">{{ $t('setting.logout') }}</a>
      <div class="tabbar-spacer"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {
        credit: 0,
        vip: 1,
        money: 0,
        username: '',
      },
      actionItems: [
        { labelKey: 'my.withdraw', icon: 'https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(31).png?updatedAt=1780093708493', path: '/Withdraw' },
        { labelKey: 'my.withdrawal_records', icon: 'https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(28).png?updatedAt=1780093709151', path: '/WithdrawRecord' },
        { labelKey: 'my.voting_record', icon: 'https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(30).png?updatedAt=1780093708524', path: '/VoteRecord' },
      ],
    };
  },
  computed: {
    accountPoint() {
      const money = Number(this.userInfo.money);
      return Number.isFinite(money) ? money.toFixed(2) : '0.00';
    },
    vipProgress() {
      const vip = Number(this.userInfo.vip) || 1;
      return Math.min(100, vip * 30);
    },
  },
  methods: {
    showSetting() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Setting' });
      } else {
        this.$router.push({ path: '/Login' });
      }
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Infomation' });
      } else {
        this.$router.push({ path: '/Login' });
      }
    },
    goPage(path) {
      if (localStorage.getItem('token')) {
        this.$router.push({ path });
      } else {
        this.$router.push({ path: '/Login' });
      }
    },
    goVipDetails() {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' });
        return;
      }
      const vip = Number(this.userInfo.vip) || 1;
      this.$router.push({ path: '/VipDetails', query: { vip: String(vip) } });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info',
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t('video.account_out'));
            localStorage.clear();
            this.$router.push({ path: '/Login' });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    loginout() {
      localStorage.clear();
      this.$router.push({ path: '/Login' });
    },
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo();
    } else {
      this.userInfo.username = this.$t('setting.log_reg');
      this.userInfo.header_img = '/img/avatar.png';
    }
  },
};
</script>

<style scoped>
.mine {
  min-height: 100vh;
  background: #f2f2f5;
  padding-bottom: 60px;
}

.top {
  background: #e89ab3;
  padding: 16px 20px 56px;
  position: relative;
}

.setting {
  padding: 4px 0 12px;
}

.avatar {
  display: flex;
  align-items: center;
  gap: 16px;
}

.avatar-fallback {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.me {
  flex: 1;
  min-width: 0;
}

.user-row {
  display: flex;
  align-items: center;
  column-gap: 12px;
}

.username {
  margin: 0;
  font-weight: bold;
  color: #fff;
  font-size: 19px;
}

.vip-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 20px;
  padding: 2px 10px 2px 6px;
  cursor: pointer;
}

.vip-badge img {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.vip-badge span {
  font-weight: bold;
  color: #7b9d9f;
  font-size: 13px;
}

.progress-wrap {
  padding: 12px 0 4px;
}

.progress-bar {
  width: 160px;
  background-color: #ebedf0;
  border-radius: 8px;
  height: 8px;
  overflow: hidden;
}

.progress-fill {
  background-color: #ffabb2;
  border-radius: 8px;
  height: 8px;
  transition: width 0.3s ease;
}

.center {
  position: relative;
  z-index: 2;
  padding: 0 16px;
  margin-top: -36px;
}

.integral {
  display: flex;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.integral-item {
  flex: 1;
  text-align: center;
  padding: 26px 12px;
}

.integral-item + .integral-item {
  border-left: 1px solid #f0f0f0;
}

.integral-label {
  color: #333;
  font-size: 17px;
  margin-bottom: 10px;
}

.integral-value {
  color: #e86892;
  font-size: 26px;
  font-weight: bold;
}

.mineJf {
  margin-top: 16px;
  background: #e89ab3;
  border-radius: 40px;
  overflow: hidden;
  animation: mineJf-expand 0.4s ease forwards;
}

.mineJf-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  gap: 12px;
}

.mineJf-text {
  flex: 1;
  text-align: left;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
}

.mineJf-vip {
  width: 64px;
  height: auto;
  object-fit: contain;
  flex-shrink: 0;
}

@keyframes mineJf-expand {
  0% {
    clip-path: inset(0 50% 0 50%);
  }
  100% {
    clip-path: inset(0 0 0 0);
  }
}

.action-list {
  margin-top: 16px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.action-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 18px;
  cursor: pointer;
}

.action-item + .action-item {
  border-top: 1px solid #f5f5f5;
}

.action-title {
  display: flex;
  align-items: center;
  gap: 14px;
  color: #333;
  font-size: 17px;
}

.action-icon img {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: block;
}

.action-button {
  color: #c8c9cc;
  font-size: 18px;
}

.btns {
  display: block;
  width: 60%;
  margin: 24px auto 0;
  padding: 18px 0;
  background: #e89ab3;
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  border-radius: 40px;
  text-decoration: none;
}

.tabbar-spacer {
  height: 60px;
}
</style>
